import type { TagColor } from "@/components/ui/tag";
import type { DeadlineStatus, ProjectStatus, WorkflowStatus } from "@/types";

export const deadlineTagColorMap: Record<DeadlineStatus, TagColor> = {
  on_track: "Neutral",
  near_deadline: "Warning",
  overdue: "Danger",
};

export const workflowTagColorMap: Record<WorkflowStatus, TagColor> = {
  created: "Neutral",
  drafting: "Secondary",
  le_review: "Info",
  pm_review: "Info Dark",
  ma_review: "Purple",
  approved: "Success",
};

export const projectTagColorMap: Record<ProjectStatus, TagColor> = {
  assessment: "Secondary",
  report: "Info",
  signatures: "Info Dark",
  on_hold: "Warning",
  completed: "Success",
  canceled: "Danger",
};
